import { dateCustom } from '../../../components';
import apiAnalytics from '../../../helpers/apiAnalytics';
import { setFiltered, loading, loaded } from '../../../layout/redux/layoutActions';

const SETOR_COLOR = '#4b5563';
const PROJETO_COLOR = '#d1d5db';

const EMPRESA_COLORS = [
  '#dc143c',
  '#00bfff',
  '#00ff7f',
  '#ffff00',
  '#6a5acd',
  '#ffa500',
  '#ff00ff',
  '#7f0000',
  '#00008b',
  '#8fbc8f',
  '#7f007f',
  '#7cfc00',
  '#808000',
  '#ff4500',
  '#b0c4de',
  '#f4a460',
  '#00ffff',
  '#ff1493',
  '#dda0dd',
  '#006400',
  '#8b4513',
  '#f0e68c',
  '#8a2be2',
  '#008b8b',
  '#696969',
  '#90ee90',
  '#b03060',
  '#f08080',
  '#9acd32',
  '#dc143c',
  '#00bfff',
  '#00ff7f',
  '#ffff00',
  '#6a5acd',
  '#ffa500',
  '#ff00ff',
  '#7f0000',
  '#00008b',
  '#8fbc8f',
  '#7f007f',
  '#7cfc00',
  '#808000',
  '#ff4500',
  '#b0c4de',
  '#f4a460',
  '#00ffff',
  '#ff1493',
  '#dda0dd',
  '#006400',
  '#8b4513'
];

export const setBenchmarkLoad = payload => ({
  type: 'LOAD_BENCHMARK',
  payload
});

export const setBenchmarkData = payload => ({
  type: 'INFO_BENCHMARK',
  payload
});

export const setBenchmarkGrafico = payload => ({
  type: 'INFO_BENCHMARK_GRAFICO',
  payload
});

export const setBenchmarkError = payload => ({
  type: 'ERROR_BENCHMARK',
  payload
});

export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_BENCHMARK',
  payload
});

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_BENCHMARK',
  payload
});

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_BENCHMARK',
});

const cortarNomeProjeto = (nome) => {
  if (!nome) {
    return 'Projeto';
  }

  if (nome.length <= 20) {
    return nome;
  }

  return `${nome.substring(0, 20)}...`;
};

const valorSfi = (item) => {
  return item?.hasData ? Number(item.sfi || 0) : 0;
};

const textoValorSfi = (item) => {
  if (!item?.hasData) {
    return 'N/A';
  }

  return Number(item.sfi || 0).toFixed(2);
};

export const montarDadosBenchmarkGrafico = ({ data, projetoNome }) => {
  if (!data || data?.iderro) {
    return [];
  }

  const benchmarkItem = {
    id: 'benchmark',
    tipo: 'benchmark',
    name: data?.benchmark?.sector || 'Benchmark',
    sfi: Number(data?.benchmark?.sfi || 0),
    valueLabel: Number(data?.benchmark?.sfi || 0).toFixed(2),
    hasData: true,
    fill: SETOR_COLOR,
    tooltip: data?.benchmark?.sector || 'Benchmark'
  };

  const projetoItem = {
    id: 'projeto',
    tipo: 'projeto',
    name: cortarNomeProjeto(projetoNome),
    sfi: valorSfi(data?.project),
    valueLabel: textoValorSfi(data?.project),
    hasData: !!data?.project?.hasData,
    fill: PROJETO_COLOR,
    tooltip: projetoNome || 'Projeto'
  };

  const empresas = data?.companies?.map((empresa, index) => ({
    id: `empresa-${index}`,
    tipo: 'empresa',
    name: empresa.name,
    sfi: valorSfi(empresa),
    valueLabel: textoValorSfi(empresa),
    hasData: !!empresa.hasData,
    deltaVsBenchmark: empresa.deltaVsBenchmark,
    fill: EMPRESA_COLORS[index % EMPRESA_COLORS.length],
    tooltip: empresa.name
  })) || [];

  return [
    benchmarkItem,
    projetoItem,
    ...empresas
  ];
};

export const carregarBenchmark = ({ projetoID, projetoNome, params }) => {
  return dispatch => {
    if (!projetoID || !params?.intervalo) {
      return;
    }

    dispatch(setBenchmarkLoad(true));
    dispatch(setBenchmarkError(null));
    dispatch(loading());

    apiAnalytics.get('/sfi/benchmark-comparison', {
      params: {
        ProjectId: projetoID,
        Intervalo: params.intervalo
      }
    })
      .then(result => {
        if (result.data?.iderro) {
          dispatch(setBenchmarkData(null));
          dispatch(setBenchmarkGrafico([]));
          dispatch(setBenchmarkError(result.data));
          dispatch(setBenchmarkLoad(false));
          return;
        }

        const grafico = montarDadosBenchmarkGrafico({
          data: result.data,
          projetoNome
        });

        dispatch(setBenchmarkData(result.data));
        dispatch(setBenchmarkGrafico(grafico));
        dispatch(setBenchmarkError(null));
        dispatch(setBenchmarkLoad(false));
      })
      .catch(err => {
        dispatch(setBenchmarkData(null));
        dispatch(setBenchmarkGrafico([]));
        dispatch(setBenchmarkError({
          iderro: 'request_error',
          complemento: err?.message || null
        }));
        dispatch(setBenchmarkLoad(false));
      })
      .finally(() => {
        dispatch(loaded());
      });
  };
};

export const filterHandle = ({ projetoID, projetoNome, params, typeSelect, filtersProvisorio }) => {
  const paramsCustom = {
    ...params,
    ciclo: params?.ciclo?.anoMesCiclo || params?.ciclo?.anoMes || params?.ciclo?.ano
      ? params.ciclo
      : filtersProvisorio.ciclo
  };

  return dispatch => {
    const paramsFilter = filtersCustom({ params: paramsCustom, typeSelect });

    dispatch(setFiltered(paramsCustom));
    dispatch(carregarBenchmark({
      projetoID,
      projetoNome,
      params: paramsFilter
    }));
  };
};

const getIntervaloCiclo = (ciclo) => {
  if (!ciclo) {
    return null;
  }

  if (ciclo.ano && ciclo.mes) {
    return `${ciclo.ano}-${ciclo.mes}`;
  }

  if (ciclo.anoMes) {
    return ciclo.anoMes;
  }

  if (ciclo.anoMesCiclo) {
    return ciclo.anoMesCiclo;
  }

  return null;
};

export const filtersCustom = ({ params, typeSelect }) => {
  let paramsFilter = {};

  if (typeSelect?.id === 'Ciclo') {
    const intervalo = getIntervaloCiclo(params?.ciclo);

    if (intervalo) {
      paramsFilter = {
        intervalo
      };
    }
  }

  if (typeSelect?.id === 'Data') {
    if (params.dataInicial && params.dataFinal) {
      paramsFilter = {
        intervalo: `${dateCustom(params.dataInicial).data} ${dateCustom(params.dataFinal).data}`
      };
    }
  }

  return paramsFilter;
};